import { render } from "./akkoOldCity.vue?vue&type=template&id=b35bae3a&scoped=true"
import script from "./akkoOldCity.vue?vue&type=script&lang=js"
export * from "./akkoOldCity.vue?vue&type=script&lang=js"

import "./akkoOldCity.vue?vue&type=style&index=0&id=b35bae3a&scoped=true&lang=css"

import exportComponent from "/media/rafa/mainDisk/Documents/Raphael/Development/NavigationApplication/efoani/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b35bae3a"]])

export default __exports__